"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacings = void 0;
exports.spacings = {
    spacing25: 2,
    spacing50: 4,
    spacing100: 8,
    spacing200: 16,
    spacing300: 24,
    spacing400: 32,
    spacing500: 40,
    spacing600: 48
};
